__webpack_require__.p = "/vma/";